import React from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {useTheme} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TopHeaderAlt = ({children}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: "100%",
                padding: '6px',
                zIndex: 1000,
                backgroundColor: theme.palette.background.paper
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width:"10%" }}>
                <IconButton
                    onClick={goBack}
                    sx={{ color: theme.palette.background.dark }}>
                    <ArrowForwardIcon />
                </IconButton>
            </Box>
            {children}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width:"10%" }}>
                <IconButton sx={{ color: theme.palette.background.dark }}>
                    {/* <ArrowForwardIcon /> */}
                </IconButton>
            </Box>
        </Box>
    );
};

export default TopHeaderAlt;